export default "__VITE_PUBLIC_ASSET__a50a00e8__"